function getTrustpilotData() {
  fetch(`https://widget.trustpilot.com/trustbox-data/56278e9abfbbba0bdcd568bc?businessUnitId=607d76edf0fef4000104260e&locale=${window.Shopify.locale}-${window.Shopify.country}`)
    .then(response => response.json())
    .then(response => {
      document.querySelectorAll('.trustCount').forEach(el => el.innerHTML = response.businessUnit.numberOfReviews.total);
      document.querySelectorAll('.trustStar').forEach(el => el.innerHTML = response.businessUnit.trustScore);

        })    
}

window.trustpilotData = getTrustpilotData();
document.addEventListener('DOMContentLoaded', function () {

  getTrustpilotData();

});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('a[href="#klaviyo"]').addEventListener('click', function (e) {
    e.preventDefault();

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'TT7VsG']);
  });
});